import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput, SpinnerLoader } from "components";
import { ACHProcessorData as ach } from "globalConstants";
import { maxLength20, minLength4, onlyDigits } from "validators/validation";

type StraddleIdentifierProps = {
	isLoading: boolean;
};

const StraddleIdentifier = ({ isLoading }: StraddleIdentifierProps) => (
	<Row>
		<Col md={6}>
			<Field
				smLabel={5}
				smSelect={7}
				component={CustomInput}
				normalize={onlyDigits}
				label={ach.StraddleIdentifier.displayName}
				name={ach.StraddleIdentifier.name}
				id={ach.StraddleIdentifier.name}
				placeholder=""
				loading={isLoading}
				validate={[minLength4, maxLength20]}
				loader={SpinnerLoader}
			/>
		</Col>
	</Row>
);

export default memo(StraddleIdentifier);
